import React from "react";
import './BrandContainer.css';

const BrandContainer = () => {
  return (
    <section className="trusted-section" id="trusted-companies">
      <p>Trusted by engineers to ace interviews at top engineering companies.</p>
      <div className="company-logos">
        <div className="logo-slide">
          {/* Extended first set for seamless flow */}
          <img src="tesla.png" alt="Tesla Logo" />
          <img src="Joby.png" alt="Joby Aviation Logo" />
          <img src="zipline.png" alt="Zipline Logo" />
          <img src="Spacex.png" alt="SpaceX Logo" />
          <img src="ABB.png" alt="ABB Logo" />
          <img src="boeing.png" alt="Boeing Logo" />
          <img src="GE.png" alt="General Electric Logo" />
          <img src="airbus.png" alt="Airbus Logo" />
          <img src="tesla.png" alt="Tesla Logo" />
          <img src="Spacex.png" alt="SpaceX Logo" />
          <img src="boeing.png" alt="Boeing Logo" />
          <img src="Joby.png" alt="Joby Aviation Logo" />
          {/* Varied duplicate set for seamless loop */}
          <img src="zipline.png" alt="Zipline Logo" />
          <img src="ABB.png" alt="ABB Logo" />
          <img src="GE.png" alt="General Electric Logo" />
          <img src="airbus.png" alt="Airbus Logo" />
          <img src="tesla.png" alt="Tesla Logo" />
          <img src="Joby.png" alt="Joby Aviation Logo" />
          <img src="zipline.png" alt="Zipline Logo" />
          <img src="Spacex.png" alt="SpaceX Logo" />
          <img src="ABB.png" alt="ABB Logo" />
          <img src="boeing.png" alt="Boeing Logo" />
          <img src="GE.png" alt="General Electric Logo" />
          <img src="airbus.png" alt="Airbus Logo" />
          <img src="tesla.png" alt="Tesla Logo" />
          <img src="Joby.png" alt="Joby Aviation Logo" />
          <img src="zipline.png" alt="Zipline Logo" />
          <img src="Spacex.png" alt="SpaceX Logo" />
        </div>
      </div>
    </section>
  );
};

export default BrandContainer;